/**
 * Module dependencies.
 */

import React from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  description: string;
};

/**
 * `Tag` styled component.
 */

const Tag = styled.span`
  background-color: #888888;
  color: white;
  margin: 0 2px;
  padding: 2px 6px;
  border-radius: 4px;
`;

/**
 * `Invalid` styled component.
 */

const Invalid = styled.span`
  background-color: red;
  color: white;
  margin: 0 2px;
  padding: 2px 6px;
  border-radius: 4px;
`;

/**
 * `parseTextWithTags` function.
 */

function parseTextWithTags(input: string) {
  const tagsFound = {
    A: false,
    B: false
  };

  const regex = /{{(A|B)}}/g;
  const parts = [];
  let lastIndex = 0;

  let match;
  while ((match = regex.exec(input)) !== null) {
    const [fullMatch, type] = match;
    const index = match.index;

    if (index > lastIndex) {
      parts.push(input.slice(lastIndex, index));
    }

    if (type === 'A' || type === 'B') {
      tagsFound[type] = true;
      parts.push(<Tag key={index}>{type}</Tag>);
    }

    lastIndex = index + fullMatch.length;
  }

  if (lastIndex < input?.length) {
    parts.push(input.slice(lastIndex));
  }

  if (!tagsFound.A || !tagsFound.B) {
    parts.push(<Invalid key={'invalid'}>{'INVALID TEXT'}</Invalid>);
  }

  return parts;
}

/**
 * Export `Description` component.
 */

export function Description({ description }: Props): JSX.Element {
  return <div>{parseTextWithTags(description)}</div>;
}
